import Upload from "../../../../src/events/2022/04/upload/main";
import * as React from 'react';
export default {
  Upload,
  React
};